
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.09 2.455V0h9.82v2.455M32.727 18L31.291 7.95a1.636 1.636 0 00-1.62-1.405H6.33c-.814 0-1.505.6-1.62 1.405L3.273 18M9 31.09V36H1.636v-4.91M34.364 31.09V36H27v-4.91"}}),_c('path',{attrs:{"d":"M36 31.09H0v-8.462c0-.868.344-1.7.959-2.313L3.273 18h29.454l2.314 2.314c.614.613.959 1.446.959 2.314v8.463z"}}),_c('circle',{attrs:{"cx":"6.545","cy":"24.545","r":"2.455"}}),_c('circle',{attrs:{"cx":"29.455","cy":"24.545","r":"2.455"}}),_c('path',{attrs:{"d":"M15.545 24.545h4.91"}})])])
          )
        }
      }
    